import { render } from "./DashbaordView.vue?vue&type=template&id=63d8b804"
import script from "./DashbaordView.vue?vue&type=script&lang=js"
export * from "./DashbaordView.vue?vue&type=script&lang=js"

import "./DashbaordView.vue?vue&type=style&index=0&id=63d8b804&lang=css"

import exportComponent from "D:\\CAS Project\\ESM Web App\\master ESM-WEB\\esm-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__